import axios from 'axios';
import React, { useContext, useState } from 'react'
import NotificationContext from '../../components/toasts/NotificationContext';
import { constants } from '../../constants';
import EmailModal from './EmailModal';

export default function ContentHome() {

  const userContact={
    name:'',
    email: '',
    phone:'',
    message: ''
  }

  const [infoUser, setInfoUser] = useState(userContact);

  const {showNotification} = useContext(NotificationContext); 

  const handleInfoUser = (e) => {
    e.preventDefault();
    setInfoUser({...infoUser, [e.target.name]: e.target.value })
  }

  const sendMail = async() => {
    const URL = constants.test_host + '/mail/send-contact-info';
    const {data} = await axios.post(URL, {infoUser}, {headers: {'Content-Type': 'application/json'}})
    showNotification('success', data.message)
    setInfoUser(userContact)
  }

  return (
    <div>
      <div>
        <section className="py-5 border-bottom" id="features">
          <div className="container px-5 my-5">
            <div className="row gx-5">
              <div className="col-lg-4 mb-5 mb-lg-0">
                <div className="feature bg-primary bg-gradient text-white rounded-3 mb-3">
                  <i className="bi bi-collection" />
                </div>
                <h2 className="h4 fw-bolder">Fideliza tus clientes</h2>
                <p>
                  Recuérdales que estás pendiente de ellos enviándoles mensajes con promociones, regalos, descuentos, etc.
                </p>
                <a className="text-decoration-none" href="#emailModal" role="button" data-bs-toggle="modal">
                  Vamos allá
                  <i className="bi bi-arrow-right" />
                </a>
              </div>
              <div className="col-lg-4 mb-5 mb-lg-0">
                <div className="feature bg-primary bg-gradient text-white rounded-3 mb-3">
                  <i className="bi bi-building" />
                </div>
                <h2 className="h4 fw-bolder">Envía confirmaciones y recordatorios</h2>
                <p>
                  Puedes enviar mensajes de confirmación de compras, de envío de pedidos, recordatorio de citas, etc.
                </p>
                <a className="text-decoration-none" href="#emailModal" role="button" data-bs-toggle="modal">
                  Vamos allá
                  <i className="bi bi-arrow-right" />
                </a>
              </div>
              <div className="col-lg-4">
                <div className="feature bg-primary bg-gradient text-white rounded-3 mb-3">
                  <i className="bi bi-toggles2" />
                </div>
                <h2 className="h4 fw-bolder">Felicítalos</h2>
                <p>
                  Con un mensaje de cumpleaños puedes demostrarles a tus clientes lo importantes que son para ti.
                </p>
                <a className="text-decoration-none" href="#emailModal" role="button" data-bs-toggle="modal">
                  Vamos allá
                  <i className="bi bi-arrow-right" />
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Pricing section*/}
        <section className="bg-light py-5 border-bottom">
          <div className="container px-5 my-5">
            <div className="text-center mb-5">
              <h2 className="fw-bolder">Precios</h2>
              <p className="lead mb-0">Paquetes disponibles</p>
            </div>
            <div className="row gx-5 justify-content-center">
              {/* Pricing card free*/}
              <div className="col-lg-6 col-xl-4">
                <div className="card mb-5 mb-xl-0">
                  <div className="card-body p-5">
                    <div className="small text-uppercase fw-bold text-muted">
                      Paquete 1
                    </div>
                    <div className="mb-3">
                      <span className="display-4 fw-bold">$110</span>
                      <span className="text-muted">/ sms.</span>
                    </div>
                    <ul className="list-unstyled mb-4">
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        <strong>150 créditos disponibles</strong>
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        1 crédito= 1 sms
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        Costo del paquete $16.500
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        Para empezar a fidelizar
                      </li>
                      
                    </ul>
                    <div className="d-grid">
                      <a className="btn btn-outline-primary" href="#emailModal" role="button" data-bs-toggle="modal">
                        Empezar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* Pricing card pro*/}
              <div className="col-lg-6 col-xl-4">
                <div className="card mb-5 mb-xl-0">
                  <div className="card-body p-5">
                    <div className="small text-uppercase fw-bold">
                      <i className="bi bi-star-fill text-warning" />
                      Paquete 2
                    </div>
                    <div className="mb-3">
                      <span className="display-4 fw-bold">$80</span>
                      <span className="text-muted">/ sms</span>
                    </div>
                    <ul className="list-unstyled mb-4">
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        <strong>350 créditos disponibles</strong>
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        1 crédito= 1 sms
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        Costo del paquete $28.000
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        Para mantener el contacto con tus clientes
                      </li>
                    </ul>
                    <div className="d-grid">
                      <a className="btn btn-primary" href="#emailModal" role="button" data-bs-toggle="modal">
                        Empezar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* Pricing card enterprise*/}
              <div className="col-lg-6 col-xl-4">
                <div className="card">
                  <div className="card-body p-5">
                    <div className="small text-uppercase fw-bold text-muted">
                      Pequete 3
                    </div>
                    <div className="mb-3">
                      <span className="display-4 fw-bold">$50</span>
                      <span className="text-muted">/ sms.</span>
                    </div>
                    <ul className="list-unstyled mb-4">
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        <strong>750 créditos disponibles</strong>
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        1 crédito= 1 sms
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        Costo del paquete $37.500
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        La opción más útil para un contacto permanente
                      </li>
                    </ul>
                    <div className="d-grid">
                      <a className="btn btn-outline-primary" href="#emailModal" role="button" data-bs-toggle="modal">
                        Empezar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      
        {/* Contact section*/}
        <section className="bg-light py-5">
          <div className="container px-5 my-5 px-5">
            <div className="text-center mb-5">
              <div className="feature bg-primary bg-gradient text-white rounded-3 mb-3">
                <i className="bi bi-envelope" />
              </div>
              <h2 className="fw-bolder">Contáctanos</h2>
              <p className="lead mb-0">Déjanos tus datos: </p>
            </div>
            <div className="row gx-5 justify-content-center">
              <div className="col-lg-6">
                <form id="contactForm" data-sb-form-api-token="API_TOKEN">
                  {/* Name input*/}
                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      id="name"
                      name='name'
                      type="text"
                      placeholder="Enter your name..."
                      onChange={(e) =>handleInfoUser(e)}
                      value= {infoUser.name}
                    />
                    <label htmlFor="name">Full name</label>
                   
                  </div>
                  {/* Email address input*/}
                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      id="email"
                      name='email'
                      type="email"
                      placeholder="name@example.com"
                      onChange={(e) =>handleInfoUser(e)}
                      value= {infoUser.email}
                    />
                    <label htmlFor="email">Email address</label>
                    <div
                      className="invalid-feedback"
                      data-sb-feedback="email:required"
                    >
                      An email is required.
                    </div>
                   
                  </div>
                  {/* Phone number input*/}
                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      id="phone"
                      name='phone'
                      type="tel"
                      placeholder="(123) 456-7890"
                      onChange={(e) =>handleInfoUser(e)}
                      value= {infoUser.phone}
                    />
                    <label htmlFor="phone">Phone number</label>
                    
                  </div>
                  {/* Message input*/}
                  <div className="form-floating mb-3">
                    <textarea
                      className="form-control"
                      id="message"
                      name='message'
                      type="text"
                      placeholder="Enter your message here..."
                      style={{ height: "10rem" }}
                      defaultValue={""}
                      onChange={(e) =>handleInfoUser(e)}
                      value= {infoUser.message}
                    />
                    <label htmlFor="message">Message</label>
                  
                  </div>
                 
                
                  {/* Submit Button*/}
                  <div className="d-grid">
                    <button
                      className="btn btn-primary btn-lg "
                      id="submitButton"
                      type="button"
                      onClick={sendMail}
                    >
                      Enviar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
        <div id="emailModal" className="modal fade" tabIndex="-1">
          <div className="modal-dialog">
            <div className='modal-content font-mulish'>
              <EmailModal />
            </div>
          </div>
        </div>
    </div>
  );
}
